import * as settingsActions from '../../actions/settingsActions/constants'

const initialState = {
    wallets: null,
    isProceedWallet: false,
    isLoadingWallets: true,
    directCurrencies: null,
    isProceedCurrency: false,
    stages: null,
    isLoadingStages: true,
    isProceedStage: false,
    appSettings: null,
    isProceedAppSettings: false,
    isLoadingAppSettings: true,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case settingsActions.GET_WALLETS_REQUEST:
            return {
                ...state,
                isLoadingWallets: true
            };
        case settingsActions.GET_WALLETS_SUCCESS:
            return {
                ...state,
                wallets: action.payload,
                isLoadingWallets: false
            };
        case settingsActions.GET_WALLETS_FAILURE:
            return {
                ...state,
                wallets: null,
                isLoadingWallets: false
            };
        case settingsActions.CREATE_WALLET_REQUEST:
            return {
                ...state,
                isProceedWallet: true
            };
        case settingsActions.CREATE_WALLET_SUCCESS:
            return {
                ...state,
                isProceedWallet: false
            };
        case settingsActions.CREATE_WALLET_FAILURE:
            return {
                ...state,
                isProceedWallet: false
            };
        case settingsActions.UPDATE_WALLET_REQUEST:
            return {
                ...state,
                isProceedWallet: true
            };
        case settingsActions.UPDATE_WALLET_SUCCESS:
            return {
                ...state,
                isProceedWallet: false
            };
        case settingsActions.UPDATE_WALLET_FAILURE:
            return {
                ...state,
                isProceedWallet: false
            };
        case settingsActions.GET_DIRECT_CURRENCIES_REQUEST:
            return {
                ...state,
                isLoadingDirectCurrencies: true
            };
        case settingsActions.GET_DIRECT_CURRENCIES_SUCCESS:
            return {
                ...state,
                directCurrencies: action.payload,
                isLoadingDirectCurrencies: false
            };
        case settingsActions.GET_DIRECT_CURRENCIES_FAILURE:
            return {
                ...state,
                directCurrencies: null,
                isLoadingDirectCurrencies: false
            };
        case settingsActions.CREATE_CURRENCY_REQUEST:
            return {
                ...state,
                isProceedCurrency: true
            };
        case settingsActions.CREATE_CURRENCY_SUCCESS:
            return {
                ...state,
                isProceedCurrency: false
            };
        case settingsActions.CREATE_CURRENCY_FAILURE:
            return {
                ...state,
                isProceedCurrency: false
            };
        case settingsActions.UPDATE_CURRENCY_REQUEST:
            return {
                ...state,
                isProceedCurrency: true
            };
        case settingsActions.UPDATE_CURRENCY_SUCCESS:
            return {
                ...state,
                isProceedCurrency: false
            };
        case settingsActions.UPDATE_CURRENCY_FAILURE:
            return {
                ...state,
                isProceedCurrency: false
            };
        case settingsActions.GET_STAGES_REQUEST:
            return {
                ...state,
                isLoadingStages: true
            };
        case settingsActions.GET_STAGES_SUCCESS:
            return {
                ...state,
                stages: action.payload,
                isLoadingStages: false
            };
        case settingsActions.GET_STAGES_FAILURE:
            return {
                ...state,
                stages: null,
                isLoadingStages: false
            };
        case settingsActions.CREATE_STAGE_REQUEST:
            return {
                ...state,
                isProceedStage: true
            };
        case settingsActions.CREATE_STAGE_SUCCESS:
            return {
                ...state,
                isProceedStage: false
            };
        case settingsActions.CREATE_STAGE_FAILURE:
            return {
                ...state,
                isProceedStage: false
            };
        case settingsActions.UPDATE_STAGE_REQUEST:
            return {
                ...state,
                isProceedStage: true
            };
        case settingsActions.UPDATE_STAGE_SUCCESS:
            return {
                ...state,
                isProceedStage: false
            };
        case settingsActions.UPDATE_STAGE_FAILURE:
            return {
                ...state,
                isProceedStage: false
            };
        case settingsActions.OPEN_CLOSE_STAGE_REQUEST:
            return {
                ...state,
                isProceedStage: true
            };
        case settingsActions.OPEN_CLOSE_STAGE_SUCCESS:
            return {
                ...state,
                isProceedStage: false
            };
        case settingsActions.OPEN_CLOSE_STAGE_FAILURE:
            return {
                ...state,
                isProceedStage: false
            };
        case settingsActions.DELETE_STAGE_REQUEST:
            return {
                ...state,
                isProceedStage: true
            };
        case settingsActions.DELETE_STAGE_SUCCESS:
            return {
                ...state,
                isProceedStage: false
            };
        case settingsActions.DELETE_STAGE_FAILURE:
            return {
                ...state,
                isProceedStage: false
            };
        case settingsActions.GET_APP_SETTINGS_REQUEST:
            return {
                ...state,
                isLoadingAppSettings: true,
            };
        case settingsActions.GET_APP_SETTINGS_SUCCESS:
            return {
                ...state,
                appSettings: action.payload,
                isLoadingAppSettings: false
            };
        case settingsActions.GET_APP_SETTINGS_FAILURE:
            return {
                ...state,
                appSettings: null,
                isLoadingAppSettings: false
            };
        case settingsActions.UPDATE_APP_SETTINGS_REQUEST:
            return {
                ...state,
                isProceedAppSettings: true
            };
        case settingsActions.UPDATE_APP_SETTINGS_SUCCESS:
            return {
                ...state,
                isProceedAppSettings: false
            };
        case settingsActions.UPDATE_APP_SETTINGS_FAILURE:
            return {
                ...state,
                isProceedAppSettings: false
            };
        default:
            return state
    }
}